import { Plane, Building2, Car, Activity, MapPin, Clock, Hash, Trash2,
  Mountain, Heart, Users, Home, Palette, Castle, Train, Ticket, Luggage,
  Smartphone, Bookmark, Flame, Snowflake, Footprints, Calendar, CircleDot,
  AlertTriangle, AlertCircle, Bus, DoorOpen, PlaneTakeoff, PlaneLanding, RefreshCw
} from 'lucide-react';

export const ICON_MAP = {
  'plane': Plane, 'plane-up': PlaneTakeoff, 'plane-landing': PlaneLanding,
  'building': Building2, 'car': Car, 'activity': Activity, 'mountain': Mountain,
  'heart': Heart, 'users': Users, 'home': Home, 'palette': Palette, 'castle': Castle,
  'train': Train, 'ticket': Ticket, 'luggage': Luggage, 'smartphone': Smartphone,
  'bookmark': Bookmark, 'flame': Flame, 'snowflake': Snowflake, 'footprints': Footprints,
  'calendar': Calendar, 'circle-dot': CircleDot, 'map-pin': MapPin, 'clock': Clock,
  'alert': AlertTriangle, 'alert-circle': AlertCircle, 'bus': Bus, 'door': DoorOpen,
  'refresh': RefreshCw, 'user': Users, 'snowboard': Snowflake, 'ice-cream': Snowflake,
  'shrine': Castle, 'trash': Trash2
};

export const STATUS_CFG = {
  confirmed: { label: 'CONFIRMED', dot: '#52b788', bg: 'bg-emerald-500/10', text: 'text-emerald-400', border: 'border-emerald-500/20' },
  urgent:    { label: 'URGENT',    dot: '#e63946', bg: 'bg-red-500/10',     text: 'text-red-400',     border: 'border-red-500/20' },
  planning:  { label: 'PLANNING',  dot: '#f4a261', bg: 'bg-amber-500/10',   text: 'text-amber-400',   border: 'border-amber-500/20' },
  passed:    { label: 'PASSED',    dot: 'rgba(255,255,255,0.06)', bg: 'bg-white/[0.03]',   text: 'text-[#b0b4c0]',   border: 'border-white/5' },
};

const TODAY = new Date().toISOString().split('T')[0];
export function getEdgeColor(entry) {
  const endDate = entry.end_date || entry.date;
  if (endDate && endDate < TODAY) return 'rgba(255,255,255,0.06)';
  return STATUS_CFG[entry.status]?.dot || STATUS_CFG.planning.dot;
}

export const PHASE_COLORS = { 'Solo': '#457b9d', 'Family': '#52b788', 'Korea + Home': '#c9a96e' };

export function getPhaseForDay(phases, day) {
  if (!phases || !day) return null;
  for (const p of phases) {
    const [start, end] = (p.days || '').split('–').map(Number);
    if (day >= start && day <= end) return p;
  }
  return null;
}

export function getIcon(name) {
  return ICON_MAP[name] || MapPin;
}

export function formatCurrency(n) {
  if (!n) return null;
  return `R ${Number(n).toLocaleString('en-ZA', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
}

const MONTHS = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
export function shortDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr + 'T00:00:00');
  if (isNaN(d)) return '';
  return `${d.getDate()} ${MONTHS[d.getMonth()]}`;
}

export function getImageUrl(url) {
  if (!url) return url;
  // Fix legacy URLs missing /api prefix
  if (url.startsWith('/uploads/')) url = '/api' + url;
  return url.startsWith('/') ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;
}
